<template>
	<WebPlayerStream
		ref="webPlayerStream"
		:on-submit-password="onSubmitPassword"
		:stream="stream"
	/>
</template>

<script>
import WebPlayerStream from "lib/components/WebPlayerStream";
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";

export default {
	name: "WebPlayerLivePage",
	components: {
		WebPlayerStream
	},
	props: {
		id: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			stream: null
		};
	},
	computed: {
		encodedId() {
			return encodeURIComponent(this.id);
		}
	},
	created() {
		this.passwordSubmitted = false;
	},
	mounted() {
		this.getStream();
	},
	methods: {
		getStream(password = "") {
			http.get(`/api/v2/recorder/stream?secid=${this.encodedId}&key=${password}`)
			.then((response) => {
				this.stream = {
					server: response.data.stream_server.hostname,
					site: location.host,
					streamId: response.data.stream_id,
					title: response.data.title
				};
				this.$refs.webPlayerStream.setup();
			})
			.catch((error) => {
				if (error.response.status === 403 &&
				    typeof error.response.data.error !== "undefined"
				) {
					this.showWebPlayerAuthenticationFeedback(error.response.data.error.message);

					return;
				}

				alert.error("Unable to get stream", error.response);
			});
		},
		onSubmitPassword(password) {
			this.passwordSubmitted = true;
			this.getStream(password);
		},
		showWebPlayerAuthenticationFeedback(errorMsg) {
			if (errorMsg.toLowerCase().indexOf("expire") === -1) {
				if (this.passwordSubmitted)
					this.$refs.webPlayerStream.$refs.webPlayerFeedback.show(true, "Wrong password, try again");
				else
					this.$refs.webPlayerStream.$refs.webPlayerFeedback.show(true, "This live stream is password protected");
			} else {
				this.$refs.webPlayerStream.$refs.webPlayerFeedback.show(false, "This link has expired");
			}
		}
	}
};
</script>
